import { twMerge } from "tailwind-merge";
import { CountBadgeBase, type CountBadgeBaseProps } from "@core/ui";

export type Props = CountBadgeBaseProps & {
  /** Theme variant */
  theme?: "light" | "dark";
};

/**
 * Styled count badge component wrapping CountBadgeBase.
 * Displays a numeric count indicator, typically used for notifications.
 */
export function CountBadge({ count, theme = "light", className, ...props }: Props) {
  return (
    <CountBadgeBase
      count={count}
      className={twMerge(
        "absolute top-0 right-0 translate-x-1/3 -translate-y-1/3 bg-red-600 text-brand-50 rounded-full w-5 h-5 flex items-center justify-center",
        "text-[11px] font-medium",
        theme === "dark" && "bg-error-700",
        className
      )}
      data-testid="count-badge"
      {...props}
    />
  );
}

export default CountBadge;

